<template>
    <div class="how-help">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h5>{{$store.getters.t('how_help_title')}}</h5>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">

                    <swiper :options="swiperOptions">

                        <swiper-slide v-for="slide in list" :key="slide.id">

                            <div class="how-help__item d-flex"
                                 :style="{backgroundColor: slide.bg,
                                                 backgroundImage: `url(${slide.image})`}">

                                <div class="how-help__title">{{$store.getters.t(slide.title)}}</div>

                            </div>

                        </swiper-slide>


                    </swiper>


                    <div class="slider-navigations" v-if="list.length">
                        <div id="how-help-prev" class="swiper-button-prev" slot="button-prev"></div>
                        <div id="how-help-next" class="swiper-button-next" slot="button-next"></div>
                    </div>

                </div>
            </div>

        </div>

    </div>
</template>

<script>

import {Swiper, SwiperSlide} from 'vue-awesome-swiper'

export default {
    name: "HowHelp",
    components:{
        Swiper,
        SwiperSlide
    },

    data(){

        return{

            swiperOptions: {
                slidesPerView: 3,
                spaceBetween: 30,
                navigation: {
                    nextEl: '#how-help-next',
                    prevEl: '#how-help-prev',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                    },
                    600:{
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    992: {
                        slidesPerView: 4,
                        spaceBetween: 30
                    },
                },
            },

            list:[
                {
                    id: 1,
                    title: 'how_help_card_bank_card',
                    image: '/assets/images/icons/help-one.svg',
                    bg: '#FEF1F1'
                },
                {
                    id: 2,
                    title: 'how_help_regular_subscription',
                    image: '/assets/images/icons/help-two.svg',
                    bg: '#FEF9EC'

                },
                {
                    id: 3,
                    title: 'how_help_non_cash_company',
                    image: '/assets/images/icons/help-three.svg',
                    bg: '#F4FBF0'

                },
                {
                    id: 4,
                    title: 'how_help_donate_goods',
                    image: '/assets/images/icons/help-four.svg',
                    bg: '#EAF1FC'


                },
                {
                    id: 5,
                    title: 'how_help_homestay_help',
                    image: '/assets/images/icons/help-five.svg',
                    bg: '#F1EEF9'
                },
                {
                    id: 6,
                    title: 'how_help_transport_help',
                    image: '/assets/images/icons/help-six.svg',
                    bg: '#F4FBF0'

                },
                {
                    id: 7,
                    title: 'how_help_pr_photo_help',
                    image: '/assets/images/icons/help-seven.svg',
                    bg: '#FEF9EC'

                },
            ]

        }

    }

}
</script>

<style lang="scss" scoped>


    .how-help{
        counter-reset: section;

        background: #fff;
        margin: 35px 0 56px;


        .swiper-button-prev, .swiper-button-next{
            background: #EAF1FC;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            transition: background .2s ease;
            &::after{

                font-size: 12px;
                line-height: 1;
                color: #2E76E4;
                transition: color .2s ease;

            }


            &:hover{

                background: #2E76E4;

                &::after{

                    color: #fff;

                }

            }

        }

        .swiper-button-prev{
            left: -30px;
        }


        .swiper-button-next{
            right: -30px;
        }

        h5{
            font-weight: bold;
            font-size: 36px;
            line-height: 44px;
            margin-bottom: 30px;
        }


        &__item{



            position: relative;
            height: auto;
            min-height: 352px;
            padding: 10px;
            text-align: center;
            align-items: center;
            justify-content: center;
            background: transparent no-repeat 95%/auto;

            background-position-y: 98%;


            &::before{

                display: block;
                position: absolute;

                left: 0;
                right: 0;
                bottom: 0;
                top: 0;

                background: transparent;
                color: #fff ;

                font-size: 80px;
                font-weight: 700;
                line-height: 1.2;
                text-align: right;


            }


        }

        &__title{
            font-weight: bold;
            font-size: 22px;
            line-height: 32px;
        }

        .swiper-slide{
            counter-increment: section;                 /* Инкрементирует счётчик*/

            .how-help__item{

                &::before{
                    content: "0" counter(section);

                }

            }

            &:nth-child(even){

                .how-help__item{

                    background-position-x: 5%;

                    &::before{
                        content: "0" counter(section);

                    }

                }

            }

        }



    }


    @media screen and (max-width: 1100px){

        .how-help{

            .slider-navigations{
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                margin-top: 10px;
            }

            .swiper-button-prev, .swiper-button-next{

                position: relative;
                left: unset;
                right: unset;

                top: unset;

                margin: 0 10px;

            }
        }


    }

    @media screen and (max-width: 768px){
        .how-help{

            h5{
                font-size: 26px;
                line-height: 30px;
                text-align: center;
            }

        }
    }


</style>
